/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/layouts/app.layouts.login.component.ts.
 */
import {Component} from '@angular/core';

/**
 * Zweck: Beschreibt class AppLayoutsLoginComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'app.layouts.login.component.html',
    standalone: false
})
export class AppLayoutsLoginComponent {

}
